import { t } from 'ttag'
import styled from 'styled-components'
import { useMutation } from 'react-query'
import { useContext, useState } from 'react'

import { Flex } from '@h2/components/layout/flex'
import { Text } from '@h2/components/typography/text'
import { Button } from '@h2/components/buttons/button'
import { api } from '@h2/api'
import { Alert } from '@h2/components/display/alert'
import { Link } from '@h2/common/components/link'
import { useNavigator } from '@h2/common/components/hooks/useNavigator'
import { Globals } from '@h2/globals'

const ProfessionalDevelopmentImage = styled.img`
  max-width: 30%;
`
const SandiProfessionalDevelopment = ({ task }) => {
  const { systemName } = useContext(Globals)
  const [success, setSuccess] = useState(false)
  const [wasError, setWasError] = useState(false)
  const navigator = useNavigator()
  const { mutate, isLoading } = useMutation(
    () =>
      api.fetch('/plans/request/sequence/sandiPD', {
        method: 'POST',
        version: 'v1',
        body: JSON.stringify({})
      }),
    {
      onSuccess: resp => {
        setWasError(false)
        setSuccess(true)
        navigator(`/planning/assignments/detail/${resp.id}`)
      },
      onError: () => {
        setWasError(true)
      }
    }
  )

  return (
    <Flex gap="20px">
      <ProfessionalDevelopmentImage src="/images/headed2/new/cards/prof_dev_graphic.svg" />
      <div>
        <Text>{t`The ${systemName} powered by Headed2 is designed to provide Nevadans with career exploration and planning resources to find gainful employment or transition to a new field. `}</Text>
        <Text>{t`The Precision Career Navigation professional development will introduce you to the ${systemName}, familiarize you with the platform and provide information to eventually help others begin their journey.`}</Text>
        {success ? (
          <Alert
            align="center"
            message={t`Professional Development Assigned Successfully`}
            type="success"
          />
        ) : (
          <>
            <Alert
              isDismissible
              isVisible={wasError}
              message={t`An error occurred while trying to assign the Professional Development, please try again`}
              type="warning"
            />

            {task.completed && task.continueUrl ? (
              <Link size="large" href={task.continueUrl} variant="button">
                {t`Continue`}
              </Link>
            ) : (
              <Button size="large" onClick={mutate} isLoading={isLoading}>
                {t`Get Started`}
              </Button>
            )}
          </>
        )}
      </div>
    </Flex>
  )
}

export { SandiProfessionalDevelopment }
